/* eslint-disable no-underscore-dangle */
import { WEEK_IN_MS } from '@ha/date';
import { getExclusion } from './exclusionDate/getExclusion';
import { NormalizedListing, AlgoliaListingRequiredSubset } from '../Types';

interface NormalizeOptions {
  currency: string;
  currencyRate: number;
}

export const normalizeListing =
  ({ currency, currencyRate }: NormalizeOptions) =>
  <T extends AlgoliaListingRequiredSubset>(item: T): NormalizedListing<T> => {
    const photos = item.photos || [];

    return {
      ...item,

      // TODO: Refactor components so only one id is used
      id: item.internalID,
      entityId: item.internalID,
      advertiser: { avatarURL: item.advertiserAvatar },
      currency,
      listingPath: item.path,
      previewImage: item.thumbnailURL,
      price: Math.round(currencyRate * item.priceEUR * 100),
      minPrice: Math.round(currencyRate * item.minPrice),
      isNew: Date.now() - item.creationDateTS * 1000 < WEEK_IN_MS,
      minimalRentalPeriod: item.minimumStayMonths,
      exclusions: [getExclusion(item.dateFrom, item.dateTo)],

      latitude: (item._geoloc && item._geoloc.lat) || null,
      longitude: (item._geoloc && item._geoloc.lng) || null,

      photos,

      unitTypeId: item.unitTypeInternalID,
    };
  };
